import { setTerminologyDictionary } from '@/composables/useTerminology'

/**
 * Keeps the terminology composable's dictionary in sync with the active
 * account's resolved terms (`auth.info.terminology`), so vue-i18n's
 * `postTranslation` hook (app/plugins/i18n.ts) always substitutes current
 * values — including immediately after switching accounts or saving new
 * overrides on the terminology settings page.
 */
export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()

  watch(
    () => authStore.info?.terminology,
    (dict) => setTerminologyDictionary(dict),
    { immediate: true, deep: true },
  )
})
